<template>
  <label
    class="float-left h-min flex flex-row items-center px-2 text-sm duration-300 ease"
    :class="theme === 'light' && !special ? 'text-black' : 'text-white'">
    {{ label }}
    <div
      v-if="required && label && !hideAsterisk"
      class="top-0 ml-1 pt-2 text-2xl font-400 leading-0 duration-300 ease"
      :class="theme === 'light' ? 'text-rose-6' : 'text-rose'">
      *
    </div>
  </label>
</template>

<script setup lang="ts">
import type { EffectiveTheme } from '@/helpers/settings';

const { label = '' } = defineProps<{
  hideAsterisk?: boolean;
  label?: string;
  required?: boolean;
  special?: boolean;
  theme?: EffectiveTheme;
}>();
</script>
